import React, { useState, useEffect } from 'react'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

import AnswerForm from './AnswerForm'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
})

const AnswerModal = props => {
  const [loading, setLoading] = useState(false)
  const [questionId, setQuestionId] = useState(props.questionId)
  const [showModal, setShowModal] = useState(props.show)

  useEffect(() => {
console.log(props.questionId);

    setQuestionId(props.questionId)

    setShowModal(props.show)

    // getData()

  }, [props.questionId, props.show])

  const getData = () => {

    setLoading(true)

    if (questionId) {
      // tasksService.getReportByTaskId(taskId)
      //   .then((res) => {

      //     let result = res.data

      //     let arr = [];

      //     unitTypes.forEach(item => {
      //       let newArr = result.taskOperations.filter(el => el.unitType === item.value);
      //       newArr.length > 0 && arr.push({ "unitType": item.label, "unitTypeId": item.value, "taskOperations": newArr });
      //     });

      //     result["taskOperations"] = arr;

      //     setData(result)

      //     console.log(res)

      //     setLoading(false)

      //   })
      //   .catch((err) => {

      //     console.log(err)

      //     setLoading(false)

      //   })
    }

  }

  const handleCloseModal = () => {

    props.onClose(false)

  }


  return (
    <React.Fragment>
      <Dialog
        open={showModal}
        onClose={() => handleCloseModal()}
        TransitionComponent={Transition}
        scroll={'paper'}
        // fullScreen={true}
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description">
        <DialogTitle>
          <Fab color="secondary" aria-label="refresh" size="small" onClick={() => handleCloseModal()} className="modal-close-btn">
            <MdClose size="20px" />
          </Fab>
          <span style={{ marginRight: 10 }}>{props.dialogTitle}</span>
        </DialogTitle>
        <DialogContent dividers={true} className="modal-gray-bg">

          <AnswerForm questionId={questionId} onClose={() => props.onClose()} />

        </DialogContent>
      </Dialog>
    </React.Fragment>
  )
}

export default AnswerModal;